import { render, staticRenderFns } from "./Obi404.vue?vue&type=template&id=e2ca46f0&scoped=true&"
import script from "./Obi404.vue?vue&type=script&lang=js&"
export * from "./Obi404.vue?vue&type=script&lang=js&"
import style0 from "./Obi404.vue?vue&type=style&index=0&id=e2ca46f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ca46f0",
  null
  
)

export default component.exports